import React, { useContext } from 'react'
import styled from 'styled-components'
import { ThemeContext } from '../providers/ThemeProvider'
import { useStateValue } from '../providers/StateProvider'
import shield from '../images/shield.svg'
import hydra from '../images/hydra.svg'

const Button = styled.button`
	background-color: transparent;
	border: none;
	cursor: pointer;
	width: 60px;
	align-self: flex-end;
	margin-right: 16px;
	padding: 0;

	img {
		height: 60px;
		width: 60px;
	}

	@media (min-width: 400px) {
		align-self: auto;
	}
`

const ModeButton = () => {
	const { mode, changeMode } = useContext(ThemeContext)
	const isEvil = mode === 'hydra'
	const { changeAlert, seenAlert } = useStateValue()

	const toggleMode = () => {
		const nextMode = mode === 'shield' ? 'hydra' : 'shield'
		const nextAlert = nextMode === 'shield' ? 0 : seenAlert
		changeMode(nextMode)
		changeAlert(nextAlert)
	}

	return (
		<Button onClick={toggleMode}>
			{isEvil ? ( <img src={shield} alt='Change to Shield Theme' /> ) : ( <img src={hydra} alt='Change to Hydra Theme' /> ) }
		</Button>
	)
}

export default ModeButton
